import React from 'react';
import { CSVLink } from 'react-csv';
import iconExport from '../../assets/icons/export.svg';
import { dataServerDTO } from '../../pages/Dashboard/index';
import { Export } from './styles';

interface dataDTO {
  data: dataServerDTO[];
}

const ExportButton = ({ data }: dataDTO) => {
  return (
    <CSVLink
      style={{ textDecoration: 'none' }}
      data={data}
      filename="Propostas.csv"
    >
      <Export>Exportar</Export>
    </CSVLink>
  );
};

export default ExportButton;
